<div class="rating-holder" style="--star-Float: {{starFloat}};">
    <ng-template #star let-fill="fill">
        <span class="star" [class.full]="fill === 100" style="--star-size: {{starSize}};">
          <span class="half" [style.width.%]="fill" style="--star-color: {{starColor}};">&#9733;</span>&#9733;
        </span>
      </ng-template>

    <ngb-rating [(rate)]="starRating" [starTemplate]="star" [readonly]="true" max="5"></ngb-rating>
    <div class="rating-numbers pd-l10">
      <span *ngIf="starRating !== 0">{{starRating}}/5</span>
      <span *ngIf="starRating === 0">NA</span>
    </div>
</div>